import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-we" }
const _hoisted_2 = { class: "dashboard-header" }
const _hoisted_3 = { class: "header-left" }
const _hoisted_4 = { class: "subtitle-main" }
const _hoisted_5 = { class: "stages-card" }
const _hoisted_6 = { class: "stages-controls" }
const _hoisted_7 = { class: "filters" }
const _hoisted_8 = { class: "dropdown-button" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "btn-wrapper" }
const _hoisted_11 = ["src"]
const _hoisted_12 = {
  key: 0,
  class: "spinner"
}
const _hoisted_13 = {
  key: 1,
  class: "empty-block--wrapper"
}
const _hoisted_14 = ["src"]
const _hoisted_15 = {
  key: 2,
  class: "table-wrapper"
}
const _hoisted_16 = { class: "table-default" }
const _hoisted_17 = ["onClick"]
const _hoisted_18 = { class: "bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h2", { class: "title-main" }, "Stages", -1)),
        _createElementVNode("h3", _hoisted_4, _toDisplayString($setup.plural($setup.stages.length, "stage")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode($setup["DropDown"], null, {
            control: _withCtx(() => [
              _createElementVNode("button", _hoisted_8, _toDisplayString($setup.activeFilter.label), 1)
            ]),
            dropdown: _withCtx(() => [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filters, (item) => {
                  return (_openBlock(), _createElementBlock("li", {
                    onClick: ($event: any) => ($setup.changeFilter(item)),
                    class: _normalizeClass({ 'dropdown__item-active': $setup.activeFilter.label === item.label })
                  }, _toDisplayString(item.label), 11, _hoisted_9))
                }), 256))
              ])
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("button", {
            class: "estate-map-link",
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.copyEstateLink()))
          }, [
            _createElementVNode("img", {
              class: "link-icon",
              src: require('@/assets/icons/link-icon.svg')
            }, null, 8, _hoisted_11),
            _cache[2] || (_cache[2] = _createElementVNode("span", null, [
              _createTextVNode("Copy masterplan link"),
              _createElementVNode("div", { class: "btn-wrapper" })
            ], -1))
          ])
        ])
      ]),
      ($setup.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12))
        : ($setup.stages.length === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
              _createElementVNode("img", {
                class: "empty-block--icon",
                src: require('@/assets/icons/lot-slim.svg')
              }, null, 8, _hoisted_14),
              _cache[3] || (_cache[3] = _createElementVNode("p", null, "You don't have stages", -1))
            ]))
          : ($setup.viewType === 'list')
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("table", _hoisted_16, [
                  _cache[4] || (_cache[4] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Stage"),
                      _createElementVNode("th", null, "Lots"),
                      _createElementVNode("th", null, "Status")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.stages, (stage) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        onClick: ($event: any) => ($setup.toStage(stage._id))
                      }, [
                        _createElementVNode("td", _hoisted_18, "Stage " + _toDisplayString(stage.title), 1),
                        _createElementVNode("td", null, _toDisplayString(stage.lotsCount), 1),
                        _createElementVNode("td", null, [
                          _createElementVNode("div", {
                            class: _normalizeClass(["badge", $setup.getStageStatusClass(stage.status)])
                          }, _toDisplayString(stage.status), 3)
                        ])
                      ], 8, _hoisted_17))
                    }), 256))
                  ])
                ])
              ]))
            : (_openBlock(), _createBlock($setup["EstateMap"], {
                key: 3,
                class: "map"
              }))
    ])
  ]))
}